import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import SessionManager from '../../components/ui/SessionManager';
import SmartExpiryRadar from '../../components/ui/SmartExpiryRadar';
import MetricCard from './components/MetricCard';
import RevenueChart from './components/RevenueChart';
import OccupancyChart from './components/OccupancyChart';
import MaintenanceBreakdown from './components/MaintenanceBreakdown';
import ContractorPerformance from './components/ContractorPerformance';
import ComplianceStatus from './components/ComplianceStatus';
import RenewalTimeline from './components/RenewalTimeline';
import ExportReportModal from './components/ExportReportModal';
import Button from '../../components/ui/Button';
import Select from '../../components/ui/Select';


const ComprehensiveReportsAnalyticsDashboard = () => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState('current-month');

  const periodOptions = [
    { value: 'current-month', label: 'Current Month' },
    { value: 'last-month', label: 'Last Month' },
    { value: 'last-3-months', label: 'Last 3 Months' },
    { value: 'last-6-months', label: 'Last 6 Months' },
    { value: 'current-year', label: 'Current Year' },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <SessionManager />

      <main className="pt-[108px] px-4 md:px-6 lg:px-8 pb-8">
        <div className="max-w-[1600px] mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-2 font-heading">
                Reports & Analytics
              </h1>
              <p className="text-sm md:text-base text-muted-foreground font-caption">
                Comprehensive business intelligence and performance monitoring
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <div className="w-full sm:w-48">
                <Select
                  options={periodOptions}
                  value={selectedPeriod}
                  onChange={setSelectedPeriod}
                  placeholder="Select period"
                />
              </div>
              <Button
                variant="default"
                iconName="Download"
                iconPosition="left"
                onClick={() => setIsExportModalOpen(true)}
              >
                Export Report
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6">
            <MetricCard
              title="Total Properties"
              value="67"
              change="+3 (4.7%)"
              changeType="positive"
              icon="Building2"
              iconColor="var(--color-accent)"
              iconBg="rgba(45, 156, 219, 0.1)"
            />
            <MetricCard
              title="Occupancy Rate"
              value="96%"
              change="+3%"
              changeType="positive"
              icon="Users"
              iconColor="var(--color-success)"
              iconBg="rgba(42, 157, 143, 0.1)"
            />
            <MetricCard
              title="Monthly Revenue"
              value="£58,000"
              change="+£3,000 (5.5%)"
              changeType="positive"
              icon="TrendingUp"
              iconColor="var(--color-success)"
              iconBg="rgba(42, 157, 143, 0.1)"
            />
            <MetricCard
              title="Open Maintenance"
              value="12"
              change="-3 (20%)"
              changeType="positive"
              icon="Wrench"
              iconColor="var(--color-warning)"
              iconBg="rgba(244, 162, 97, 0.1)"
            />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 mb-6">
            <RevenueChart />
            <OccupancyChart />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mb-6">
            <div className="lg:col-span-2">
              <ComplianceStatus />
            </div>
            <MaintenanceBreakdown />
          </div>

          <div className="mb-6">
            <SmartExpiryRadar variant="full" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
            <div className="lg:col-span-2">
              <ContractorPerformance />
            </div>
            <RenewalTimeline />
          </div>
        </div>
      </main>

      <ExportReportModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
      />
    </div>
  );
};

export default ComprehensiveReportsAnalyticsDashboard;